import { Context } from 'Context/Context';
import useIsMobile from 'Hooks/useIsMobile';
import React, { useContext, useEffect, useState } from 'react'

function SortingOptions({sortOptions, setOffset, setSortOptions, setUpdateComp,selectedSort, setSelectedSort}) {
    const {userDetails} = useContext(Context);
    const isMobile = useIsMobile();

    const sortData = [{
        "name" : "Date of incident - recent first",
        "value" : {"field" : "dateInfo", "order" : -1 },
    },
    {
        "name" : "Date of incident - oldest first",
        "value" : {"field" : "dateInfo", "order" : 1 },
    },
    {
        "name" : "Most requested first",
        "value" : {"field" : "requested", "order" : -1 },
        
    },
    {
        "name" : "Least requested first",
        "value" : {"field" : "requested", "order" : 1 },

    },
    {
        "name" : "Most reviewed first",
        "value" : {"field" : "reviewed", "order" : -1 },

    },
    {
        "name" : "Least reviewed first",
        "value" : {"field" : "reviewed", "order" : 1 },

    },
    {
        "name" : "Adverse party net worth ↑",
        "value" : {"field" : "adversePartyNetWorth", "order" : -1 },
        "premium" : true,
    },
    {
        "name" : "Adverse party net worth ↓",
        "value" : {"field" : "adversePartyNetWorth", "order" : 1 },
        "premium" : true,
    }
]
const onChange = (e) => {
    setOffset(0);
    const sortObj = JSON.parse(e.target.value);
    setSortOptions(e.target.value);
    sortData.map((obj) => {
        // console.log("obj", obj.value.field, sortObj?.field, obj.value.order, sortObj?.order);
        if(obj.value.field === sortObj.field && obj.value.order === sortObj.order)
        {
            console.log(obj.name)
            setSelectedSort(obj.name);
        }
    })
    setUpdateComp((prev) => !prev);
}
const [isOpen, setIsOpen] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
  const handleSelect = (option) => {
    if (option.premium && !userDetails?.isActiveSubscription) return;
    setSelectedId(option.id);
    onChange({ target: { name: "caseType", value: JSON.stringify(option.value) } });
    setIsOpen(false);
  };
  const ref = React.useRef(null);
  useEffect(() => {
    if (!isOpen) return undefined;
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setIsOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [isOpen]);
  return (
    <div ref={ref} className="relative font-plexsans flex-none">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center transition-colors gap-1.5 font-plexsans font-medium text-[12.5px] leading-none text-navy bg-white border border-navy/[.15] rounded-md py-2 px-3 whitespace-nowrap ${isMobile ? 'max-w-[160px]' : 'max-w-[320px]'}`}
      >
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="rgba(20,33,61,.55)" strokeWidth="2.2" strokeLinecap="round" className="flex-none"><path d="M7 4v16M7 20l-3-3M7 20l3-3M17 20V4M17 4l-3 3M17 4l3 3" /></svg>
        <span className="text-navy/[.55]">Sort{isMobile ? '' : ':'}</span>
        {!isMobile && <span className="overflow-hidden text-ellipsis">{selectedSort}</span>}
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="rgba(20,33,61,.55)" strokeWidth="2.4" strokeLinecap="round" className={`flex-none${isOpen ? ' rotate-180' : ''}`}><path d="M6 9l6 6 6-6" /></svg>
      </button>
      {isOpen && (
        <div className="absolute z-20 top-[calc(100%+6px)] right-0 w-[280px] bg-white border border-navy/[.15] rounded-lg shadow-[0_16px_36px_-12px_rgba(20,33,61,.4)] p-1.5 max-h-[320px] overflow-y-auto">
          {sortData.map((obj) => {
            const locked = obj.premium && !userDetails?.isActiveSubscription;
            const sel = obj.name === selectedSort;
            return (
              <div
                key={JSON.stringify(obj.value)}
                onClick={() => handleSelect(obj)}
                className={`flex items-center justify-between gap-2 py-[9px] px-2.5 rounded-[5px] font-plexsans text-[13px] leading-[1.3] ${sel ? 'font-semibold' : 'font-normal'} ${obj.premium ? 'text-brass' : 'text-navy'} ${locked ? 'cursor-not-allowed opacity-50' : 'cursor-pointer opacity-100 hover:bg-navy/[.04]'}`}
                title={locked ? 'Premium sort — subscribe to use it' : undefined}
              >
                {obj.name}
                {sel && <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#14213d" strokeWidth="2.6" strokeLinecap="round"><path d="M5 12l5 5L20 7" /></svg>}
              </div>
            );
          })}
        </div>
      )}
    </div>
  )
}

export default SortingOptions
